import { useQuery } from "@tanstack/react-query";
import axiosManager from "../services/axiosManager";

export const useGetSafeguardingTypes = () => {
    const {
        isFetching: isLoading, data: safeguardingTypes, error,
    } = useQuery({
        queryKey: ["SafeguardingTypes"],
        queryFn: () => axiosManager.get$("/parent/api/SafeguardingTypes").then((response) => response?.data),
        initialData: [],
        retry: 0,
    });

    const safeguardingTypesOptions = (safeguardingTypes || []).map((item) => ({ value: item.safeguardingTypeId, label: item.description, name: item.name }));

    return {
        isLoading, safeguardingTypes, error, safeguardingTypesOptions,
    };
};
